export default __webpack_public_path__ + "static/media/posScreen3.f146bd41.png";